const Palette = () => {

    const contrastText = '#fff';

    const paletteColor = {
        menuMain: {
            main: '#FFFFFF',
            contrastText: '#111111',
            hoverText: '#111111'
        },
        simCard: {
            main: '#FFFFFF',
            contrastText: '#111111'
        },
        profileMenuContainer: {
            main: 'transparent',
            contrastText
        }
    };

    return {
        ...paletteColor,
    }
}
export default Palette;
